export enum MarketingAllowanceCode {
  NonConnectBi = "99",
}
